<template>
  <div style = "width: 100%">
    <div class="formWidth register__form" v-if="step === 0">
      <ValidationProvider
        name="Amount"
        :rules="amountRules"
        v-slot="{ errors, classes }"
      >
      <UpiDialog
        v-if="showUPIDialog"
        :showUPIDialog="showUPIDialog"
        @closeDialog="closeUPIDialog"
      />
      <div class = "divFlexBox" >
        <div class = "amountWidth">
            <div class="backButtonOne mb-20" v-if="!hideBackButton">
              <button class="btn-back btn w-45px" @click="goBack">
                <v-icon class="material-icons-round"> arrow_back </v-icon>
              </button>
            </div>
            <label style="color: #232323; font-size: 16px;" class="register--label" for="mobile"><strong>Amount</strong></label>
            <div class="input-group mb-5" :class="classes">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <v-icon class="material-icons-round">currency_rupee</v-icon>
                </span>
              </div>
              <input
                type="number"
                placeholder="50,000"
                class="form-control"
                v-model="amount"
                :disabled="disableAmountField"
                @input="validateAmount"
              />
            </div>
            <small class="form-group--error-message">{{ errors[0] }}</small>
            <p v-if ="!hideMinimumInvest" class = "investment font-size-sm">Minimum investment ₹5,000</p>
            <!-- <p style = "color: #9E9E9E" class = "investment font-size-xxs fontItalics">Max upto 50 Lakh</p> -->
          </div>
        </div>
        <div class="payment-methods">
          <form :action="payment_url" method="post" ref="form">
            <input type="hidden" name="key" :value="paymentKey" />
            <input type="hidden" name="txnid" :value="transactionId" />
            <input type="hidden" name="productinfo" :value="productInfo" />
            <input type="hidden" name="amount" :value="paymentAmount" />
            <input type="hidden" name="email" :value="emailId" />
            <input type="hidden" name="firstname" :value="firstName" />
            <input type="hidden" name="lastname" :value="lastName" />
            <input type="hidden" name="surl" :value="callbackUrl" />
            <input type="hidden" name="furl" :value="callbackUrl" />
            <input type="hidden" name="phone" :value="phoneNo" />
            <input type="hidden" name="udf1" :value="paymentVariable" />
            <input
              type="hidden"
              name="enforce_paymethod"
              :value="enforcePayMethod"
            />
            <input type="hidden" name="hash" :value="hash" ref="hash" />
            <div class="paymentMethodsWrapper">
              <p class="paymentMethodText">Pay using</p>
              <div
                class="widthCard white-box payment-methods__content forhove"
                :class="isWalletActive"
                @click="paymentOption('wallet', errors)"
                v-if="showEscrow"
              >
              <div class = "paymentBox">
                <h2 class = "imageAlignment">Escrow Wallet</h2>
                <div class = "paymentTextContainer">
                  <p class = "feesText">Fees: ₹0</p>
                  <p class="processingText">Available Balance: ₹{{
                      escrowBalance
                    }}</p>
                </div>
              </div>
              </div>
              <div
                class="widthCard white-box payment-methods__content forhove"
                :class="{ activeMethod: paymentMethod === 'netTwo' }"
                @click="paymentOption('netTwo', errors)"
              >
                <div class = "paymentBox">
                    <img class = "imageAlignment" id = "UPI_image" alt="UPI Transfer" />
                  <div class = "paymentTextContainer">
                    <p class = "feesText">Fees: ₹2.36</p>
                    <p class="processingText">
                      Processing time: upto 72 hours after transfer
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="widthCard white-box payment-methods__content forhove"
                :class="{ activeMethod: paymentMethod === 'netOne' }"
                @click="paymentOption('netOne', errors)"
              >
                <div class = "paymentBox">
                    <img class = "imageAlignment" id = "Net_banking" alt="Net Banking" />
                  <div class = "paymentTextContainer">
                    <p class = "feesText">Fees: ₹17.7</p>
                    <p class="processingText">
                      Processing time: upto 72 hours after transfer
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="!hideBankTransfer"
                class="widthCard white-box payment-methods__content forhove"
                :class="{ activeMethod: paymentMethod === 'neft' }"
                @click="paymentOption('neft', errors)"
              >
                <div class = "paymentBox">
                    <img class = "imageAlignment" id = "Bank_transfer" alt="Bank Transfer" />
                  <div class = "paymentTextContainer">
                    <p class = "feesText">IMPS/NEFT/RTGS</p>
                    <p class="processingText">
                      Processing time: upto 24 hours after transfer
                    </p>
                  </div>
                </div>
                <p style = "padding-top: 16px; color: #6a6a6a !important" class="processingText">
                  *A virtual escrow account with YES Bank is ready for you to which you can transfer funds via IMPS/NEFT/RTGS.
                </p>
              </div>
            </div>
          </form>
          <div style="display: flex; justify-content: center; align-items: center" class="register__form--referral-bottom">
            <button
              class="payButton mt-15 btn_new btn-secondary-new mb-5"
              @click="pay"
              :disabled="!(errors.length === 0) || !paymentMethod || isPayDisabled"
            >
              Pay &#x20B9;
              {{ ((parseFloat(amount) + charges|| 0)) | localeAmountNormal }}
            </button>
          </div>
          <div style="padding-top: 15px; display: flex; justify-content: center; align-items: center;">
            <div class = "RBI_container">
              <p class = "RBI_text">RBI Licensed NBFC P2P - COR No: N.13-02409</p>
            </div>
          </div>
        </div>
      </ValidationProvider>
    </div>
    <div v-if="paymentMethod === 'wallet' && step === 1" class="planContainer paymentMethods">
      <Wallet :portfolio="portfolio" :manualInvestment="manualInvestment" />
      <PlanCard v-if="showProduct" :portfolio="portfolio" />
      <div class="register__form--referral-bottom">
        <button
          class="btn btn-secondary w-80 mt-30 mb-15"
          v-if="!hideContinueButton"
          @click="next"
        >
          Continue
        </button>
      </div>
    </div>
    <div
      v-else-if="paymentMethod === 'neft' && step === 1"
      class="planContainer paymentMethods"
    >
      <NetBanking :portfolio="portfolio" />
      <PlanCard v-if="showProduct" :portfolio="portfolio" />
      <div style="display: flex; justify-content: center; align-items: center" class="register__form--referral-bottom">
        <button
          class="btn_new btn-secondary-new mt-15 mb-15"
          @click="bankTransfer"
        >
          Continue
        </button>
      </div>
    </div>
    <div
      v-else-if="
        (paymentMethod === 'netOne' || paymentMethod === 'netTwo') && step === 1
      "
      class="paymentMethods"
    >
      <div>
        <div class="backButtonOne" v-if="isTransactionStatus === 'failed'">
          <button
            class="btn-back btn w-45px mt-15 mb-15"
            @click="backToPaymentOptions"
          >
            <v-icon> fas fa-chevron-left </v-icon>
          </button>
        </div>
        <div class="netTitle">
          <div v-if="isTransactionStatus === 'success'" class="icon">
            <img src="/img/paymentSuccess.png" alt="Payment Successful" />
          </div>
          <div v-else-if="isTransactionStatus === 'failed'" class="icon">
            <img src="/img/paymentFailed.png" alt="Payment Successful" />
          </div>
          <div class="transactionMessage">{{ transactionMessage }}</div>
        </div>
        <div class="white-box plan-selection__plan text-black">
          <ul class="choose-plan">
            <li class="choose-plan__item">
              <span class="choose-plan__item--paymentType">Transaction ID</span>
              <span class="choose-plan__item--text darken">{{
                paymentTransactionId
              }}</span>
            </li>
            <li class="choose-plan__item">
              <span class="choose-plan__item--paymentType">Amount</span>
              <div class="choose-plan__item--text darken">
                <div class="amountBreakdown">
                  &#x20B9;{{ (transactionAmount) | localeAmount }} +
                  &#x20B9;{{ charges }}
                </div>
              </div>
            </li>
            <li class="choose-plan__item">
              <span class="choose-plan__item--paymentType">Date/Time</span>
              <span class="choose-plan__item--text darken">{{
                transactionDate
              }}</span>
            </li>
            <li
              class="choose-plan__item"
              v-if="isTransactionStatus === 'success'"
            >
              <span class="bold"
                >Your funds will take upto 72 hours to reflect in your
                investment account.</span
              >
            </li>
            <li
              class="choose-plan__item"
              v-if="isTransactionStatus === 'failed'"
            >
              <span class="bold"
                >Your transaction has failed. Please go back to try
                again!.</span
              >
            </li>
          </ul>
        </div>
        <div
          v-if="isTransactionStatus === 'success'"
          style = "display: flex; flex-direction: column; align-items: center"
          class="register__form--referral-bottom"
        >
          <button class="btn_new btn-secondary-new w-80 mt-15 mb-15" @click="transactionSuccess">
            Continue
          </button>
        </div>
      </div>
    </div>

    <v-snackbar v-model="showAmountPrompt" app timeout="-1">
      Please add the investment amount before proceeding!
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="showAmountPrompt = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import NetBanking from '@/components/paymentMethods/netBanking'
import Wallet from '@/components/paymentMethods/wallet'
import PlanCard from '@/components/common/planCard/planCard.vue'
import UpiDialog from '@/components/common/paymentComponent/UpiWarningDialog.vue'
import LenderService from '@/services/lenderService'
import LoggerService from '@/services/LoggerService'
import crypto from 'crypto'
import onboardingService from '@/services/lenderOnboardingService'

export default {
    name: 'PaymentComponent',
    props: {
        hideMinimumInvest: {
            value: false,
            type: Boolean
        },
        showProduct: Boolean,
        showEscrow: Boolean,
        hideBankTransfer: Boolean,
        isFirstTime: Boolean,
        transactionPurpose: String,
        selectedPortfolio: Object,
        investmentAmount: Number,
        customProps: Object,
        minimumAmount: Number
    },
    components: {
        UpiDialog,
        Wallet,
        NetBanking,
        PlanCard
    },
    data () {
        return {
            inputType: 'text',
            showUPIDialog: false,
            amount: null,
            queries: null,
            amountRules: 'paymentAmountValidation:5000000,1|required',
            portfolio: null,
            paymentMethod: '',
            step: 0,
            escrowBalance: 0,
            hideContinueButton: false,
            hideBackButton: false,
            manualInvestment: null,
            disableAmountField: false,
            showAmountPrompt: false,
            paymentKey: null,
            transactionId: null,
            productInfo: null,
            emailId: null,
            firstName: null,
            lastName: null,
            callbackUrl: null,
            phoneNo: null,
            hash: null,
            transactionAmount: null,
            isTransactionStatus: true,
            transactionMessage: 'Payment Successful',
            paymentTransactionId: '',
            paymentVariable: '',
            transactionDate: '',
            charges: 0,
            paymentAmount: 0,
            mode: null,
            enforcePayMethod: '',
            payment_url: process.env.VUE_APP_PAYMENT_ENDPOINT,
            isPayDisabled: false
        }
    },
    watch: {
        queries: function (value) {
            this.queries = value
            this.queryHandler()
        },
        amount: function (value) {
            this.paymentMethod = ''
            if (!this.amount) {
                this.showAmountPrompt = true
            }
        }
    },
    async mounted () {
        if (this.selectedPortfolio) {
            this.portfolio = this.selectedPortfolio
        } else {
            this.portfolio = this.$store.getters['portfolio/getPortfolio']
        }
        if (this.portfolio.investmentAmount === 0 && this.transactionPurpose === 'portfolioDirect') {
            this.hideMinimumInvest = false
            this.minimumAmount = 5000
        }
        this.queries = this.$route.query
        if (this.showEscrow) {
            this.escrowBalance =
        this.$store.getters['dashboard/getChartDetails'].escrowBalance
        }
        if (this.queries) {
            if (Object.keys(this.queries).length) {
                this.queryHandler()
            }
        }
        if (this.customProps) {
            if (this.customProps.investmentAmount) {
                this.amount = this.customProps.investmentAmount
            }
            if (this.customProps.investmentType === 'manual') {
                this.manualInvestment = {
                    investmentAmount: this.amount,
                    investmentType: 'manual',
                    lenderInterestRate: this.customProps.lenderInterestRate
                }
            }
            if (this.customProps.hideContinueButton) {
                this.hideContinueButton = true
            }
            if (this.customProps.hideBackButton) {
                this.hideBackButton = true
            }
            if (this.customProps.disableAmountField) {
                this.disableAmountField = true
            }
        }

        const data = await this.getInvestmentData()
        let upperLimitValue = data.paymentUpperLimit - data.investmentAmount
        const investmentAmountLocale = data.investmentAmount.toLocaleString('en-US')
        if (upperLimitValue <= 0) {
            upperLimitValue = 0
        }
        this.amountRules = `paymentAmountValidation:${upperLimitValue},1,${this.isFirstTime},${data.investmentAmount},${investmentAmountLocale}|required`

        if (this.minimumAmount) {
            this.amountRules = `paymentAmountValidation:${upperLimitValue},${this.minimumAmount},${this.isFirstTime},${data.investmentAmount},${investmentAmountLocale}|required`
        }
    },
    created () {
        this.paymentKey = process.env.VUE_APP_PAYMENT_KEY
        this.productInfo = process.env.VUE_APP_PRODUCT_INFO
        this.emailId = this.$store.state.onBoarding.Email
        const name = this.$store.state.onBoarding.Name || this.$store.state.userName
        const splitName = name.split(' ')
        this.firstName = splitName[0]
        this.lastName = splitName[-1]
        this.callbackUrl = process.env.VUE_APP_PAYMENT_CALLBACK
        this.phoneNo = this.$store.state.dashboard.phoneNo
        this.salt = process.env.VUE_APP_PAYMENT_SALT
    },
    computed: {
        isWalletActive () {
            if (!this.escrowBalance || this.escrowBalance < this.amount) {
                return 'disabled'
            } else if (this.paymentMethod === 'wallet') {
                return 'activeMethod'
            }
            return ''
        }
    },
    methods: {
        async getInvestmentData () {
            const response = await Promise.all([
                LenderService.getSystemConfiguration(),
                LenderService.getMonthlyInvestmentAmount()
            ])
            return {
                paymentUpperLimit: Number(response[0].data.paymentUpperLimit),
                investmentAmount: Number(response[1].data.investmentAmount)
            }
        },
        closeUPIDialog () {
            this.showUPIDialog = false
            this.paymentMethod = null
        },
        queryHandler () {
            if (this.queries) {
                if (Object.keys(this.queries).length) {
                    this.paymentQueries = this.queries
                    this.step = 1
                    this.paymentMethod = 'netOne'
                    this.hideBackButton = true
                    if (this.queries.status === 'success') {
                        this.isTransactionStatus = 'success'
                        this.transactionMessage = 'Payment Successful'
                    } else {
                        this.isTransactionStatus = 'failed'
                        this.transactionMessage = 'Payment Failed'
                    }
                    this.paymentTransactionId = this.queries.txnid
                    this.transactionDate = this.queries.addedon
                    if (this.queries.mode === 'payu-NB') {
                        this.mode = 'netOne'
                        this.charges = 15 + 0.18 * 15
                    } else if (this.queries.mode === 'payu-UPI') {
                        this.mode = 'netTwo'
                        this.charges = 2 + 0.18 * 2
                    } else {
                        this.charges = 0
                    }
                    this.transactionAmount = this.queries.amount
                }
            }
        },
        paymentOption (option, errors) {
            if (errors.length) {
                return
            }
            if (!this.amount) {
                this.showAmountPrompt = true
            }
            if (option === 'wallet') {
                if (this.amount > this.escrowBalance) {
                    return null
                }
            }
            this.charges = 0
            if (this.amount) {
                this.paymentMethod = option
                this.portfolio.investmentAmount = this.amount * 100
                this.$store.commit('portfolio/setField', {
                    field: 'investmentAmount',
                    val: this.amount
                })
                if (this.paymentMethod === 'netOne') {
                    this.charges = 15 + 0.18 * 15
                } else if (this.paymentMethod === 'netTwo') {
                    this.charges = 2 + 0.18 * 2
                }
            }
            if (this.paymentMethod === 'netTwo' && parseFloat(this.amount) + this.charges > 100000) {
                this.showUPIDialog = true
            }
        },
        async pay () {
            this.paymentAmount = parseFloat(this.amount) + this.charges
            if (this.paymentMethod === 'neft') {
                this.step = 1
                this.hideBackButton = true
                this.bankTransfer()
            } else if (this.paymentMethod === 'wallet') {
                this.step = 1
                this.hideBackButton = true
            } else if (
                this.paymentMethod === 'netOne' ||
                this.paymentMethod === 'netTwo'
            ) {
                this.$store.commit('isLoading')
                const lenderInfo = await LenderService.getLenderOnboardingInfo()
                this.emailId = lenderInfo.data.emailId
                this.phoneNo = lenderInfo.data.phoneNo

                const name = lenderInfo.data.name
                const splitName = name.split(' ')
                this.firstName = splitName[0]
                this.lastName = splitName[-1]
                if (this.paymentMethod === 'netOne') {
                    this.enforcePayMethod = 'netbanking'
                } else {
                    this.enforcePayMethod = 'upi'
                }
                this.$store.commit('portfolio/setField', {
                    field: 'isInTransaction',
                    val: true
                })
                this.$store.commit('portfolio/setField', {
                    field: 'status',
                    val: 'pending'
                })
                if (this.transactionPurpose === 'portfolioDirect' || this.transactionPurpose === 'portfolio') {
                    this.paymentVariable = `transactionPurpose=${this.transactionPurpose},portfolioId=${this.portfolio.portfolioId},userId=${this.$store.state.dashboard.userId},actualAmount=${this.amount}`
                } else if (this.transactionPurpose === 'funds') {
                    this.paymentVariable = `transactionPurpose=${this.transactionPurpose},userId=${this.$store.state.dashboard.userId},actualAmount=${this.amount}`
                }
                const txnId = `${this.phoneNo}${new Date().getTime()}`
                this.transactionId = txnId
                const text = this.paymentKey + '|' + this.transactionId + '|' + this.paymentAmount + '|' +
                    this.productInfo + '|' + this.firstName + '|' + lenderInfo.data.emailId +
                    '|' + this.paymentVariable +
                    '||||||||||' +
                    this.salt

                var hashObj = await crypto.createHash('sha512')

                var data = await hashObj.update(text, 'utf-8')

                var generatedHash = data.digest('hex')

                this.hash = generatedHash
                const payloadObj = {}
                payloadObj.username = this.phoneNo
                payloadObj.log = text + ' hash value ' + generatedHash
                try {
                    await LoggerService.logger(payloadObj)
                } catch (err) {
                }
                this.submitForm()
            }
        },
        submitForm () {
            this.isPayDisabled = true
            this.$refs.form.submit()
            this.$store.commit('isNotLoading')
        },
        validateAmount () {
            const amount = this.amount
            const sep = String(12.21).match(/\D/)[0]
            const b = amount.split(sep)
            if (b[1]) {
                if (b[1].length > 2) {
                    this.amount = b[0] + '.' + b[1].slice(0, 2)
                }
            }
        },
        async bankTransfer () {
            if (this.transactionPurpose === 'portfolio') {
                this.$store.commit('isLoading')
                const payload = {
                    portfolioId: this.portfolio.portfolioId,
                    investmentAmount: this.amount * 100
                }
                LenderService.editPortfolio(payload).then(async (res) => {
                    if (res.status === 200) {
                        this.next()
                    } else {
                    }
                })
                this.$store.commit('isNotLoading')
            } else if (this.transactionPurpose === 'portfolioDirect') {
                this.$router.push('/bank-transfer')
            }
        },
        goBack () {
            this.$router.replace({ query: {} })
            if (this.paymentMethod) {
                this.paymentMethod = null
                this.step = 0
                this.$emit('goBack')
            } else {
                this.$emit('goBack')
            }
        },
        backToPaymentOptions () {
            this.$router.replace({ query: {} })
            this.hideBackButton = false
            this.paymentMethod = null
            this.step = 0
        },
        next () {
            this.$emit('success')
        },
        facebookConversion () {
            const payload = {}
            payload.EventName = 'purchase'
            onboardingService.facebookConversionAPI(payload).then(async (res) => {})
        },
        transactionSuccess () {
            if (this.isFirstTime === true) {
                this.facebookConversion()
            }
            this.next()
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/sass/components/registration-flow.scss";
@import "@/components/dashboard/dashboard.scss";

.payButton {
}
.paymentTextContainer {
  max-width: 350px;
  min-width: 280px
}
.feesText {
  text-align: right;
  font-weight: 400;
  font-size: 14px;
  color: #6a6a6a;
  padding-bottom: 10px
}
.processingText {
  font-weight: 400;
  font-size: 11px;
  text-align: right;
  font-style: italic;
}
.paymentBox {
  display: flex;
  flex-direction: row;
}
.imageAlignment {
  padding-right: 20px;
  max-height: 60px !important;
  max-width: 87px !important;
  min-height: 60px !important;
  min-width: 87px !important;
}
.investment {
  text-align: right;
  color: #6A6A6A;
  font-weight: 300;
  font-family: 'Inter', sans-serif
}
.RBI_text {
  text-align: center;
  font-size: 14px;
  color: #000000;
  font-weight: 600;
}
.RBI_container {
  width: 600px;
  padding-top: 8px;
  padding-bottom: 8px;
  background-color: rgb(224,224,224,0.4);
  text-align: center;
  border-radius: 10px
}
.choose-plan__item--paymentType {
    font-size: 16px
}
.choose-plan__item--text darken {
    font-size: 14px
}
.bold {
    padding-top: 8px;
    font-size: 18px;
    color: #4f4f4f
}
.payment-methods {
  display: block;
  .paymentMethodsWrapper {
    align-items: center;
    flex-direction: column !important;
    display: flex;
    justify-content: space-between;
  }

  &__content {
    border: 1px solid $light-grey;
    padding: 10px;
    position: relative;
    margin: 10px;
    flex-basis: 150px;
    flex-grow: 1;
    h2 {
      font-size: $h4-font-size;
      font-weight: $font-weight-medium;
    }
    .fa-chevron-right {
      position: absolute;
      right: 20px;
      color: $primary;
      top: 50%;
      transform: translateY(-50%);
    }
    .fa-rupee-sign {
      font-size: $font-size-xxs;
      position: relative;
      top: -2px;
      color: $black;
    }
  }

  &__pay-info {
    @include flex(flex, center, flex-start);
    span {
      margin-right: 15px;
      font-size: $font-size-md;
      font-weight: $font-weight-normal;
      i {
        position: relative;
        top: -1px;
        margin-right: 5px;
        color: $black;
      }
    }
  }
}
.white-box.disabled {
  background-color: rgb(241, 239, 239);
  cursor: unset !important;
  color: #666e75;
}
.white-box {
  cursor: pointer !important;
}
.v-application p {
  margin-bottom: 0px;
}
.netTitle {
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon img {
    width: 60px;
    height: 60px;
  }

  .transactionMessage {
    padding-bottom: 24px;
    font-size: 24px;
    font-weight: 600;
  }
}
.activeMethod {
      background: linear-gradient(
      90.19deg,
      #0b1133 25%,
      #071a90 75%
    ) !important;

  h2,
  p,
  span {
    color: $white !important;
  }

  .v-icon.v-icon {
    color: $white !important;
  }
  #UPI_image {
  content: url('/img/upi-light.svg')
  }

  #Bank_transfer {
  content: url('/img/bank-transfer-light.svg')
  }

  #Net_banking {
  content: url('/img/Netbanking-light.svg')
  }
}
.amount {
  font-size: 18px;
  font-weight: 550 !important;
  letter-spacing: 2px;
}
#UPI_image {
  content: url('/img/upi-dark.svg')
}

#Bank_transfer {
  content: url('/img/bank-transfer-dark.svg')
}

#Net_banking {
  content: url('/img/Netbanking-dark.svg')
}
.forhove {
  &:hover {
    background: linear-gradient(
      90.19deg,
      #0b1133 25%,
      #071a90 75%
    ) !important;

    h2,
    p,
    span {
      color: $white !important;
    }

    .v-icon.v-icon {
      color: $white !important;
    }

  #UPI_image {
    content: url('/img/upi-light.svg')
  }
  #Bank_transfer {
    content: url('/img/bank-transfer-light.svg')
  }
  #Net_banking {
    content: url('/img/Netbanking-light.svg')
  }
  }
}
.register__form {
  min-width: 600px !important;
}
@media (max-width: 990px) {
  .white-box,
  .px-50 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .paymentMethods .white-box {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }

  .dashboard__leftpanel {
    display: none;
  }

  .payment-methods form .paymentMethodsWrapper {
    display: flex !important;
    flex-direction: column !important;
    align-items: center;
  }

  .payment-methods .payment-methods__content {
    border: 1px solid $light-grey;
    padding: 10px;
    margin-top: 12px;
    height: unset;
  }

  .register__form {
    min-width: unset !important;
  }
  .widthCard {
    width: 300px !important;
    max-height: 91px !important;
    min-height: 88px !important;
  }
  .paymentMethodText {
  max-width: 340px !important;
  min-width: 300px !important;
  }
  .divWidth {
  max-width: 100% !important;
  }
  .paymentTextContainer {
  max-width: 400px;
  min-width: 180px
  }
  .planContainer {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 20px !important;
  }
  .amountWidth {
  max-width: 386px;
  min-width: 300px !important
  }
}
.amountBreakdown {
  display: flex;
  justify-content: space-between;
}
.v-icon.v-icon {
  font-size: 24px;
}

::placeholder {
  color: #e0e0e0
}
.widthCard {
  width: 400px;
  max-height: 80px;
  min-height: 80px;
}

.paymentMethodText {
  font-size: 18px;
  padding-top: 12px;
  max-width: 400px;
  min-width: 400px;
}

.divWidth {
  max-width: 80%;
}
.formWidth {
  max-width: 100%;
}
.amountWidth {
  max-width: 400px;
  min-width: 400px
}
.divFlexBox {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.planContainer {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 150px;
  padding-right: 150px;
  padding-top: 30px
}
::v-deep .v-card__title {
    line-height: 20px !important
}

::v-deep .v-card__title {
    line-height: 21px ;
}
</style>
